__webpack_public_path__ = process.env.ASSET_PATH;

import './bootstrap';

// Permite debugar com Vue DevTools na página de impressão (usa app-generic.js em layout_master_print)
if (typeof window !== 'undefined' && window.Vue && (window.env === 'local' || window.Laravel?.environment !== 'production')) {
    window.Vue.config.devtools = true;
}

import './classes';
import './directives';
import VueRouter from 'vue-router';

window.EventBus = new Vue();

Vue.component('card-files-invite-store', ()=>import(/* webpackPreload: true */'./Generic/InviteStores/card-files-invite-store.vue'));
Vue.component('approved-products-view', ()=>import(/* webpackPreload: true */'./Generic/Project/01_Print/01_ApprovedProducts/approved-products-view.vue'));
Vue.component('suppliers', ()=>import(/* webpackPreload: true */'./Generic/Project/01_Print/02_Suppliers/suppliers.vue'));
Vue.component('project-view', ()=>import(/* webpackPreload: true */'./Generic/Project/project-quotation-view.vue'));
Vue.component('album-print-page', ()=>import(/* webpackPreload: true */'./AlbumPrint/album-print-page.vue'));
Vue.component('budget', ()=>import(/* webpackPreload: true */'./Generic/Project/Components/budget.vue'));
Vue.component('project-items', ()=>import(/* webpackPreload: true */'./Generic/Project/Components/project-items.vue'));
Vue.component('project-book', ()=>import(/* webpackPreload: true */'./Generic/Project/Book/project-book.vue'));
Vue.component('modal-card', ()=>import(/* webpackPreload: true */'./Components/modal-card.vue'));
Vue.component('select-add', ()=>import(/* webpackPreload: true */'./Components/select-add'));
Vue.component('editable-span', ()=>import(/* webpackPreload: true */'./Components/editable-span'));
Vue.component('quotation-print-page', ()=>import(/* webpackPreload: true */'./QuotationPrint/quotation-print-page.vue'));
Vue.component('service-order-print', ()=>import(/* webpackPreload: true */'./ServiceOrderPrint/service-order-print.vue'));
Vue.component('production-order-print', ()=>import(/* webpackPreload: true */'./ServiceOrderPrint/production-order-print.vue'));

let router = new VueRouter();

import {mix_general} from "./mixins";

import { Form, Errors } from './classes';

import {mask} from 'vue-the-mask'
export default {
  directives: {mask}
}

const isProd = window.Laravel['environment'] === 'production'

import VueAnalytics from 'vue-analytics'
Vue.use(VueAnalytics, {
    id: 'UA-105448081-1',
    debug: {
        enabled: !isProd,
        sendHitTask: isProd
    },
    linkers: ['hoopdecor.com', 'elevato.com.br']
})

window.vueappGeneric = new Vue({

    mixins:[mix_general],
    el: '#app',
    router,
    data: {
        isLoadingGeneral: false,
        global: {
            environment: window.Laravel['environment'],
            adminApiToken: window.Laravel['admin_api_token'],
        },
    },

    created() {
    },

    mounted() {
        this.isLoadingGeneral=true;
    },

    methods: {
    },

});
